import type { ButtonProps } from '@mui/material';
import { Button } from '@mui/material';
import type { ElementType } from 'react';

interface OrgThemedButtonProps<C extends ElementType = 'button'>
  extends ButtonProps {
  component?: C;
  target?: string;
}
/*
OrgThemedButton uses default MUI theming rather than our overrides
defined in FT elements. It handles contrast automatically and hover states
*/
export const OrgThemedButton = <C extends ElementType = 'button'>({
  size = 'large',
  ...props
}: OrgThemedButtonProps<C>) => {
  return (
    <Button
      dir='auto'
      {...props}
      size={size}
      sx={{
        border:
          props.variant === 'contained' ? '1px solid transparent' : '1px solid',
        borderRadius: '20px',
        fontFamily: 'inherit',
        fontSize: '14px',
        height: size === 'large' ? '40px' : '32px',
        lineHeight: 1,
        minWidth: 'initial',
        padding: size === 'large' ? '10px 24px' : '6px 16px',
        typography: size === 'large' ? 'font14Bold' : 'font14Medium',
        ...props.sx,
      }}
    />
  );
};
